import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'WebPage' | 'Organization' | 'Service' | 'FAQPage' | 'Product';
  data: Record<string, unknown>;
}

export function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': type,
      ...data
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
}

export const organizationSchema = {
  name: 'theintimateedit',
  url: import.meta.env.VITE_SITE_URL || 'https://theintimateedit.com',
  logo: `${import.meta.env.VITE_SITE_URL || 'https://theintimateedit.com'}/logo.png`,
  description: 'Surprise decoration specialists creating unforgettable intimate moments for romantic proposals, birthdays, anniversaries, and celebrations.',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '500'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    availableLanguage: 'English'
  }
};

export const serviceSchema = {
  '@type': 'Service',
  name: 'Surprise Decoration Services',
  provider: {
    '@type': 'Organization',
    name: 'theintimateedit'
  },
  serviceType: 'Event Decoration',
  description: 'Professional surprise decoration services for romantic proposals, birthdays, anniversaries, and intimate celebrations',
  areaServed: 'Worldwide',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Surprise Decoration Packages',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Intimate Evening Package',
          description: 'Rose petals, candles, fairy lights, personalized message, photo-ready styling, setup & cleanup'
        },
        price: '299',
        priceCurrency: 'USD'
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Grand Gesture Package',
          description: 'Premium balloon arch, luxury floral arrangements, custom signage, professional photography, extended setup'
        },
        price: '599',
        priceCurrency: 'USD'
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Sweet Surprise Package',
          description: 'Balloon bouquet, fresh flowers, decorative banner, sweet treats display, quick setup'
        },
        price: '199',
        priceCurrency: 'USD'
      }
    ]
  }
};
